
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { UserPlus } from "lucide-react";
import { TeamInviteModal } from "./TeamInviteModal";

interface TeamInviteButtonProps {
  teamId: string;
  teamName: string;
  variant?: "default" | "secondary" | "outline" | "ghost";
  size?: "default" | "sm" | "lg" | "icon";
}

export function TeamInviteButton({ 
  teamId, 
  teamName, 
  variant = "default", 
  size = "default" 
}: TeamInviteButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        variant={variant || "default"}
        size={size}
        onClick={() => setIsModalOpen(true)}
        className="flex items-center gap-2 relative font-medium bg-primary text-primary-foreground hover:bg-primary/90"
      >
        <UserPlus className="h-5 w-5" />
        <span>Invite Team Member</span>
      </Button>
      
      <TeamInviteModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        teamId={teamId}
        teamName={teamName}
      />
    </>
  );
}
